module.exports = __webpack_public_path__ + "static/media/tapping.0a99a47e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/patient-hope/tapping.gif
// module id = 374
// module chunks = 0